import { RegisterCard } from "../../components/RegisterCard";
import { TimeSelect } from "../../components/TimeSelect";
import { MediaUploadInput } from "../../components/MediaUploadInput";
import { CircleLoader } from "../../components/CircleLoader";
import { Moon, Clock } from "lucide-react";

export const CAsleep = ({
  formData,
  onFormChange,
  onFormSubmit,
  loading,
}: any) => {
  return (
    <div className="w-full max-w-4xl mx-auto p-4">
      <RegisterCard
        title="Sleep Log"
        details="Track nap times and rest periods."
      />
      <form
        onSubmit={onFormSubmit}
        className="mt-6 bg-white rounded-[2.5rem] border border-slate-100 shadow-xl overflow-hidden flex flex-col lg:flex-row"
      >
        <div className="flex-1 p-8 space-y-6 order-2 lg:order-1">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-2">
              <label className="text-xs font-black text-slate-400 uppercase tracking-widest">
                Start Nap
              </label>
              <div className="h-12 border-2 border-slate-100 rounded-xl bg-slate-50 flex items-center px-2">
                <TimeSelect
                  value={formData.start_time}
                  onChange={(val: string) => onFormChange("start_time", val)}
                />
              </div>
            </div>
            <div className="space-y-2">
              <label className="text-xs font-black text-slate-400 uppercase tracking-widest">
                Wake Up
              </label>
              <div className="h-12 border-2 border-slate-100 rounded-xl bg-slate-50 flex items-center px-2">
                <TimeSelect
                  value={formData.end_time}
                  onChange={(val: string) => onFormChange("end_time", val)}
                />
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <label className="text-xs font-black text-slate-400 uppercase tracking-widest">
              Description
            </label>
            <textarea
              value={formData["description"]}
              onChange={(e) => onFormChange("description", e.target.value)}
              className="w-full p-4 bg-slate-50 border-2 border-slate-100 rounded-2xl min-h-[100px] outline-none"
              placeholder="How did they sleep?"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full h-16 bg-blue-900 text-white rounded-2xl font-black uppercase tracking-widest"
          >
            {loading ? <CircleLoader /> : "Log Sleep"}
          </button>
        </div>
        <div className="lg:w-64 bg-slate-900 flex items-center justify-center p-8 order-1 lg:order-2">
          <img
            src="/img/sleeping.svg"
            className="w-40 h-40 drop-shadow-2xl"
            alt="sleep"
          />
        </div>
      </form>
    </div>
  );
};
